import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { I18n } from 'react-redux-i18n-lite';
import Textarea from 'react-textarea-autosize';
import { SmartButton } from '../../common/SmartButton';
import UserImage from '../../common/UserImage';
import { MAX_LENGTH_VARIABLES } from '../../../const';

class NewMessageInput extends Component {
  static propTypes = {
    onSaveMessage: PropTypes.func.isRequired,
    onCancel: PropTypes.func,
    showCancelButton: PropTypes.bool,
    hideUserAvatar: PropTypes.bool,
    user: PropTypes.object.isRequired,
    disabled: PropTypes.bool,
    initialValue: PropTypes.string,
    closedMessage: PropTypes.string
  };

  state = {
    messageText: '',
    nCharacters: 0
  };

  componentDidMount() {
    const { initialValue } = this.props;
    this.setState({
      messageText: initialValue || '',
      nCharacters: initialValue ? initialValue.length : 0
    });
  }

  onInputMessage = event => {
    let message = event.target.value;
    if (message.length > MAX_LENGTH_VARIABLES.COMMENT) {
      message = message.slice(0, MAX_LENGTH_VARIABLES.COMMENT);
    }
    this.setState({
      messageText: message,
      nCharacters: message.length
    });
  };

  saveMessage = () => {
    const { onSaveMessage } = this.props;
    const { messageText } = this.state;
    onSaveMessage(messageText.replace(/(<([^>]+)>)/gi, ''));
    this.setState({ messageText: '', nCharacters: 0 });
  };

  showCancelButton = () => {
    const { onCancel } = this.props;

    return <SmartButton onClick={onCancel}>{I18n.t('discussions.common.cancel')}</SmartButton>;
  };

  render() {
    const { messageText, nCharacters } = this.state;
    const { user, showCancelButton, disabled, hideUserAvatar, closedMessage } = this.props;

    const disableInput = { disabled };

    return (
      <div className="new-post">
        <div className="new-post-input-text">
          {!hideUserAvatar && <UserImage picture={user.picture} classes="no-border" size={38} />}
          <Textarea
            onInput={this.onInputMessage}
            value={messageText}
            {...disableInput}
            placeholder={I18n.t('discussions.common.postInputPlaceholder')}
            className="textarea-post"
          />
        </div>
        <div className="max-characters-blur">{`${nCharacters}/${MAX_LENGTH_VARIABLES.COMMENT}`}</div>
        <div className="submit-button">
          {closedMessage && <span className="closed-message">{closedMessage}</span>}
          {showCancelButton ? this.showCancelButton() : ''}
          <SmartButton onClick={this.saveMessage} disabled={disabled || !messageText || messageText === ''} success>
            {I18n.t('discussions.common.sendPost')}
          </SmartButton>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    user: state.account.user
  };
}

export default connect(mapStateToProps)(NewMessageInput);
